/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo popup
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    var Popup = kendo.ui.Popup;
    if (!Popup || Popup.updated) return;

    var BOTTOM = "bottom",
        RIGHT = "right",
        CENTER = "center";

    // TODO : Kendo tooltip positioning
    // limit tooltip wrapper position / size to widget ( element's wrapper )

    // TODO : "top" as default position doesn't work - The problem is the measured
    // popup content size can be smaller than actual size, thus the text can be
    // wrapped to more rows, but the position is not recalculated for the first time
    // when the popup is displayed. Next opening of popup usually triggers new position
    // recalculation, which fixes the problem. Can we fix it with CSS ?

    // TODO : popup position doesn't consider CSS transforms, solution ?

    /**
     * Considers offset specified in options when positioning the popup.
     * Works only for positions other then center.
     */
    function popupAlign(origin, position) {
        var self = this,
            element = self.wrapper,
            anchor = $(self.options.anchor),
            verticalOrigin = origin[0],
            horizontalOrigin = origin[1],
            verticalPosition = position[0],
            horizontalPosition = position[1],
            optionsOffset = self.options.offset || 0,
            anchorOffset = kendo.getOffset(anchor),
            appendTo = $(self.options.appendTo),
            appendToOffset,
            width = element.outerWidth(),
            height = element.outerHeight(),
            anchorWidth = anchor.outerWidth(),
            anchorHeight = anchor.outerHeight(),
            top = anchorOffset.top,
            left = anchorOffset.left,
            round = Math.round;
        // commenting out this condition fixed body CSS transform issue
        // otherwise the popups were misplaced
        // TODO : is there a case where this will break something ?
        // if( appendTo[ 0 ] !== document.body ) {
        appendToOffset = kendo.getOffset(appendTo);
        top -= appendToOffset.top;
        left -= appendToOffset.left;
        // }
        if (verticalOrigin === BOTTOM) top += round(anchorHeight + optionsOffset);
        if (verticalOrigin === CENTER) top += round(anchorHeight / 2);
        if (verticalPosition === BOTTOM) top -= round(height + optionsOffset);
        if (verticalPosition === CENTER) top -= round(height / 2);
        if (horizontalOrigin === RIGHT) left += round(anchorWidth + optionsOffset);
        if (horizontalOrigin === CENTER) left += round(anchorWidth / 2);
        if (horizontalPosition === RIGHT) left -= round(width + optionsOffset);
        if (horizontalPosition === CENTER) left -= round(width / 2);
        self.info(
            "popupAlign()\n\t params - origin : %o, position : %o" +
            "\n\t anchor : %o, optionsOffset : %s, anchorOffset : %o, appendToOffset : %o" +
            "\n\t result - left : %s, top : %s",
            origin, position, anchor, optionsOffset, anchorOffset, appendToOffset, left, top
        );
        if (!anchor.parent().length)
            self.warning("Popup anchor element doesn't have a parent. Position will probably be wrong.");
        return { top: top, left: left };
    }

    /**
     * Considers offset specified in options when positioning the popup.
     * Works only for positions other then center.
     */
    function popupFlip(offset, size, anchorSize, viewPortSize, origin, position, boxSize) {
        var self = this,
            optionsOffset = self.options.offset || 0,
            output = 0;
        boxSize = boxSize || size;
        if (position !== origin && position !== CENTER && origin !== CENTER) {
            if (offset + boxSize > viewPortSize) output += -(anchorSize + size + 2 * optionsOffset);
            if (offset + output < 0) output += anchorSize + size;
        }
        return output;
    }

    /**
     * The original widget "class" gets updated in two steps. First is constructor
     * update. newInit function becomes the new constructor of the component.
     * In the constructor the widget is also republished as kendo plugin, so that
     * jQuery.fn gets updated. Second step is overriding of specific widget methods
     * when needed.
     */
    var oldPopupInit = Popup.fn.init,
        oldTabKeyTrap = Popup.TabKeyTrap,
        newPopupInit = function (element, options) {
            var self = this,
                $element = $(element);
            // update options from specifically prefixed data on element
            options = kendo.elementOptions($element, "popup", options);
            // call original constructor
            oldPopupInit.call(self, element, options);
        };

    Popup = Popup.extend({
        // new init
        init: newPopupInit,
        // default options extension
        options: kendo.getUpdatedWidgetOptions({
            offset: 0
        }),
        // updated methods
        _align: popupAlign,
        _flip: popupFlip
    });

    Popup.TabKeyTrap = oldTabKeyTrap;

    Popup.updated = true;

    kendo.ui.plugin(Popup);

})(window.kendo.jQuery);
